import { IconWrapper } from '../runtime';
export default IconWrapper('quote', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M6.61807 3.95291C6.8796 3.74077 6.97689 3.50189 6.87437 3.24405C6.77185 2.9862 6.36376 2.95573 6.1469 3.04631C6.02125 3.09878 5.61064 3.35348 5.39887 3.49713C5.1871 3.64078 4.46415 4.16393 3.47882 5.14803C2.49348 6.13213 1.25 7.95594 1.25 10.1234L1.25303 10.1208L1.25302 10.1259C1.25302 11.7132 2.54143 13 4.13075 13C5.72008 13 7.00849 11.7132 7.00849 10.1259C7.00849 8.70784 5.98026 7.52965 4.62781 7.29447L4.63277 7.29032L4.58151 7.28311C4.31813 7.24664 4.1056 7.2172 4.18702 6.81967C4.26155 6.45573 4.90754 5.3767 5.79398 4.62238C5.95143 4.4884 6.1575 4.32309 6.35581 4.16402C6.44667 4.09114 6.5359 4.01956 6.61807 3.95291Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M14.3593 3.95291C14.6208 3.74077 14.7181 3.50189 14.6156 3.24405C14.5131 2.9862 14.105 2.95573 13.8881 3.04631C13.7625 3.09878 13.3519 3.35348 13.1401 3.49713C12.9283 3.64078 12.2054 4.16393 11.22 5.14803C10.2347 6.13213 8.99121 7.95594 8.99121 10.1234L8.99424 10.1208L8.99423 10.1259C8.99423 11.7132 10.2826 13 11.872 13C13.4613 13 14.7497 11.7132 14.7497 10.1259C14.7497 8.70784 13.7215 7.52965 12.369 7.29447L12.374 7.29032L12.3227 7.28311C12.0593 7.24664 11.8468 7.2172 11.9282 6.81967C12.0028 6.45573 12.6488 5.3767 13.5352 4.62238C13.6926 4.48841 13.8987 4.32313 14.097 4.16407C14.1877 4.09126 14.2772 4.0195 14.3593 3.95291Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});